export default {"src":"/_next/static/media/UAL.0a10292c.svg","height":18,"width":18};